define(function(require) {

    const modalHtml = '<div class="modal fade" id="GuidedTour_modal" tabindex="-1" role="dialog" aria-labelledby="Visite guidée de la carte" aria-hidden="true">' +
                            '<div class="modal-dialog modal-lg">' +
                                '<div class="modal-content">' +
                                    '<div class="modal-header">' +
                                        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                                        '<h4 class="modal-title">Visite guidée de l\'atlas de la diplomation et de la qualification par cohorte au secondaire</h4>' +
                                    '</div>' +
                                    '<div class="modal-body">' +
                                        '<div class="container-fluid">' +
                                            '<div class="row">' +
                                                '<h5><strong>L\'atlas est composé des sections suivantes :</strong><br><small><em>Veuillez cliquer sur une des sections ci-dessous pour lancer la visite guidée.</em></small></h5>' +
                                            '</div>' +
                                        '<div class="row vertical-align">' +
                                            '<dl class="dl-horizontal">' +
                                                '<dt><button type="button" value="bandeau" class="btn btn-default btn-block startTour" data-dismiss="modal">L\'entête</button></dt>' +
                                                '<dd>L\'entête, en bleu, comprend le titre de l\'atlas, le menu déroulant permettant de sélectionner une thématique ainsi que les boutons pour accéder à l\'outil d\'impression et à l\'aide.</dd>' +
                                            '</dl>' +
                                        '</div>' +
                                        '<div class="row">' +
                                            '<dl class="dl-horizontal">' +
                                                '<dt><button type="button" value="carte" class="btn btn-default btn-block startTour" data-dismiss="modal">La carte</button></dt>' +
                                                '<dd>La carte constitue l\'élément central où sont affichées les différentes thématiques. Des outils cartographiques sont également disponibles pour naviguer et pour sélectionner ou interroger des objets géographiques.</dd>' +
                                            '</dl>' +
                                        '</div>' +
                                        '<div class="row">' +
                                            '<dl class="dl-horizontal">' +
                                                '<dt>' +
                                                    '<div class="dropdown">' +
                                                        '<button type="button" class="btn btn-default btn-block dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Le panneau latéral&nbsp;<span class="caret"></span></button>' +
                                                        '<ul class="dropdown-menu" style="position:relative; border:0;" role="menu">' +
                                                            '<li><button type="button" value="panelConstat" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">Le constat</button></li>' +
                                                            '<li><button type="button" value="panelRecherche" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">L\'outil de recherche</button></li>' +
                                                            '<li><button type="button" value="panelGraphiques" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">Les graphiques</button></li>' +
                                                            '<li><button type="button" value="panelInfo" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">L\'outil Info</button></li>' +
                                                            '<li><button type="button" value="panelLegende" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">La légende</button></li>' +
                                                        '</ul>' +
                                                    '</div>' +
                                                '</dt>' +
                                                '<dd>Le panneau latéral est composé de différentes sections dynamiques qui se mettent à jour automatiquement en fonction de la thématique active et des objets sélectionnés dans la carte. Ces sections sont : le constat, l\'outil de recherche qui permet de localiser un objet géographique en particulier, les graphiques, l\'outil Info et la légende de la carte.</dd>' +
                                            '</dl>' +
                                        '</div>' +
                                        '<div class="row">' +
                                            '<dl class="dl-horizontal">' +
                                                '<dt>' +
                                                    '<div class="dropdown">' +
                                                        '<button type="button" class="btn btn-default btn-block dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Le panneau inférieur&nbsp;<span class="caret"></span></button>' +
                                                        '<ul class="dropdown-menu" style="position:relative; border:0;" role="menu">' +
                                                            '<li><button type="button" value="panelDonnees" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">Les données</button></li>' +
                                                            '<li><button type="button" value="panelDiagrammes" class="btn btn-default btn-xs btn-block startTour" role="menuitem" data-dismiss="modal">Les diagrammes</button></li>' +
                                                        '</ul>' +
                                                    '</div>' +
                                                '</dt>' +
                                                '<dd>Le panneau inférieur est composé de trois sections. Les deux premiers onglets nommés <em>Données</em> et <em>Sélection</em> permettent de consulter les tableaux de données des différentes couches présentent dans la carte. L\'onglet <em>Diagrammes</em> permet de consulter des graphiques complémentaires à la thématique active.</dd>' +
                                            '</dl>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>';

    var config = {
        "bandeau": {
            steps: [{
                title: "L'entête",
                element: ".cv-mapTitle",
                content: "Titre de l'atlas",
                placement: "bottom"
            }, {
                title: "L'entête",
                element: ".cv-btnThemeSetList",
                content: "Titre de la thématique active",
                placement: "bottom"
             }, {
                title: "L'entête",
                element: ".cv-btnPrint",
                content: "Outil d'impression",
                placement: "bottom"
            }, {
                title: "L'entête",
                element: ".cv-btnHelp",
                content: "Accès à la visite guidée et à la documentation",
                animation: false,
                placement: "bottom"
            }, {
                title: "L'entête",
                element: ".cv-btnThemeSetList",
                content: "Cliquer pour ouvrir l'arborescence et choisir une thématique",
                placement: "right",
                onShown: function(tour) {
                    $(this.element).click();
                },
                onPrev: function(tour) {
                    $(".cv-header-themesetListPopup").parent().css({"display": "none"});
                }
            }, {
                title: "L'entête",
                element: "#-kendoPopupWindow-CvThemeSetListTreeView-treeView_tv_active",
                content: "La thématique active est surlignée en bleu",
                placement: "left",
                onShow: function(tour) {
                    $(".cv-header-themesetListPopup").parent().css({"display": ""});
                }
            }, {
                title: "L'entête",
                element: ".cv-header-themesetListPopup",
                content: "Naviguer à l'intérieur des arborescences pour afficher les différentes thématiques disponibles, puis cliquer sur celle à afficher dans la carte.",
                placement: "left",
                onShow: function(tour) {
                    $(".cv-header-themesetListPopup").parent().css({"display": ""});
                }
            }],
            onTourEnd: function() {
                $(".cv-header-themesetListPopup").parent().css({"display": "none"});
            }
        },
        "carte": {
            steps: [{
                title: "La carte",
                element: ".cv-initialExtentTool",
                content: "Vue initiale : Zoom à la vue initiale",
                placement: "bottom",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "La carte",
                element: ".cv-zoomInTool",
                content: "Zoom avant : Dessiner un rectangle sur la carte pour afficher une vue plus détaillée",
                placement: "bottom",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "La carte",
                element: ".cv-zoomOutTool",
                content: "Zoom arrière : Cliquer sur la carte pour afficher une vue moins détaillée",
                placement: "bottom",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "La carte",
                element: ".cv-infoPanTool",
                content: "Info et Recentrer : Cliquer sur la carte pour visualiser l'information associée à un objet de la carte ou déplacer la carte pour recentrer",
                placement: "bottom",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "La carte",
                element: ".BtnSelectionMenuToolArrow",
                content: "Ouvrir le menu de sélection",
                placement: "bottom",
                onShown: function(tour) {
                    $(this.element).click();
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                }
            }, {
                title: "La carte",
                element: ".cv-selectionMenuToolLayersList .k-input",
                content: "Définir la couche dont les entités seront sélectionnables",
                placement: "right",
                onPrev: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "none");
                },
                onShow: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                }
            }, {
                title: "La carte",
                element: ".cv-simpleSelectionTool",
                content: "Sélection : Sélectionner les entités géographiques en cliquant sur la carte (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                placement: "bottom",
                onShow: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                }
            }, {
                title: "La carte",
                element: ".cv-circularSelectionTool",
                content: "Sélection circulaire : Dessiner un cercle sur la carte pour sélectionner des entités géographiques (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                placement: "bottom",
                onShow: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                }
            }, {
                title: "La carte",
                element: ".cv-rectangularSelectionTool",
                content: "Sélection rectangulaire : Dessiner un rectangle sur la carte pour sélectionner des entités géographiques (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                placement: "bottom",
                onShow: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                }
            }, {
                title: "La carte",
                element: ".cv-polygonalSelectionTool",
                content: "Sélection polygonale : Dessiner un polygone sur la carte pour sélectionner des entités géographiques (double-cliquer pour fermer) (utiliser les touches Maj et Ctrl pour faire une sélection multiple)",
                placement: "bottom",
                onShow: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                }
            }, {
                title: "La carte",
                element: ".cv-unselectAllTool",
                content: "Désélectionner tout : Désélectionner toutes les entités géographiques",
                placement: "bottom",
                onPrev: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "");
                },
                onShow: function(tour) {
                    $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "none");
                },
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "La carte",
                element: ".cv-zoomBar button:eq(0)",
                content: "Applique un zoom à partir du centre de la carte pour afficher une vue plus détaillée",
                placement: "right",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "La carte",
                element: ".cv-zoomBar button:eq(1)",
                content: "Applique un zoom à partir du centre de la carte pour afficher une vue moins détaillée",
                placement: "right",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "La carte",
                element: ".cv-exportTool",
                content: "Exporter une image de la carte",
                placement: "bottom"
            }, {
                title: "La carte",
                element: ".cv-scaleBar",
                content: "Échelles graphique et numérique de la carte",
                placement: "right",
                duration: 6000
            }],
            onTourStart: function() {
                $(".cv-toolbar, .cv-zoomBar, .cv-exportTool").css({
                    "opacity": "1",
                    "transition": "all 0 ease 0"
                });
            },
            onTourEnd: function() {
                $(".cv-popup.cv-selectionMenuToolPopup").parent().css("display", "none");
                $(".cv-toolbar, .cv-zoomBar, .cv-exportTool").css({
                    "opacity": "",
                    "transition": ""
                });
                $(".cv-infoPanTool").click();
            }
        },
        "panelConstat": {
            steps: [{
                title: "Le constat",
                element: "#Constat_panel_btn",
                content: "Constat: Constat, méthodologie et notes de la thématique active",
                placement: "left",
                onShown: function(tour) {
                    window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("Constat_panel").activate();
                }
            }, {
                title: "Le constat",
                element: "#Constat_panel",
                content: "Cette section contient une brève description de la thématique active ainsi que de l'information sur la méthodologie utilisée",
                placement: "left",
                onShown: function(tour) {
                    $("#Constat_panel a:eq(1)").click();
                }
            }]
        },
        "panelRecherche": {
            steps: [{
                title: "Recherche",
                element: ".cv-btnToggleSearchView",
                content: "Recherche : Faire une recherche à partir des couches de la carte",
                placement: "left",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "Recherche",
                element: ".cv-searchView .k-dropdown",
                content: "Sélectionner la couche dans laquelle rechercher",
                placement: "left",
                duration: 6000,
                onShown: function(tour) {
                    var dropDownList = $(".cv-searchView-dropDown:eq(1)").data("kendoDropDownList");
                    dropDownList.open();
                    dropDownList.select(3);
                },
                onHide: function(tour) {
                    var dropDownList = $(".cv-searchView-dropDown:eq(1)").data("kendoDropDownList");
                    dropDownList.trigger("select");
                    dropDownList.close();
                }
            }, {
                title: "Recherche",
                element: ".cv-searchView-textBox",
                content: "Taper un élément de recherche",
                placement: "left"
            }, {
                title: "Recherche",
                element: ".cv-searchView .k-grid-content tr:eq(4)",
                content: "Résultats de la recherche : cliquer sur un élément de la liste pour centrer la carte sur l'entité",
                placement: "left",
                duration: 6000,
                onShown: function(tour) {
                    $(".cv-searchView-listBox").data("kendoGrid").select("tr:eq(4)");
                }
            }]
        },
        "panelGraphiques": {
            steps: [{
                title: "Les graphiques",
                element: "#BbGraphs_rightPanel_btn",
                content: "Les graphiques : Afficher les données de la thématique active sous forme de graphiques",
                placement: "left",
                onShown: function(tour) {
                    window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("BbGraphs_rightPanel").activate();
                }
            }, {
                title: "Les graphiques",
                element: "#BbGraphs_rightPanel",
                content: "Les graphiques : Survoler les graphiques avec la souris pour afficher les valeurs",
                placement: "left",
            }, {
                title: "Les graphiques",
                element: "#BbGraphs_rightPanel",
                content: "Les graphiques : Cliquer sur un élément d'un graphique pour zoomer la carte sur l'entité géographique associée",
                placement: "left",
            }, {
                title: "Les graphiques",
                element: "#BbGraphs_rightPanel",
                content: "Les graphiques : Les graphiques se mettent à jour en fonction des entités géographiques sélectionnés",
                placement: "left",
                onShow: function(tour) {
                    var layer = window.cartovista.externalInterface.map.getLayer("GEO09E01_CS_FRA_STA_GEN");
                    layer.getFeatures(null, function(result) {
                        layer.selectFeatures(_.map(_.sampleSize(result.features, 8), "id"));
                    });
                },
                onHide: function(tour){
                    var layer = window.cartovista.externalInterface.map.getLayer("GEO09E01_CS_FRA_STA_GEN");
                    layer.selectFeatures([]);
                }
            }, {
                title: "Les graphiques",
                element: "#BbGraphs_rightPanel .BbGraphs_printBtn",
                content: "Les graphiques : Exporter les graphiques dans un document PDF",
                placement: "left",
                onShow: function(tour) {
                    $("#BbGraphs_rightPanel .BbGraphs_printBtn").removeClass("easeOut").addClass("easeIn");
                }
            }]
        },
        "panelInfo": {
            steps: [{
                title: "Information",
                    element: ".cv-btnToggleInfoView",
                content: "Information : Afficher les informations associées aux entités de la carte questionnées avec l'outil Info",
                placement: "left",
                onShown: function(tour) {
                    window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("infoView").activate();
                    $(".cv-infoView").addClass("cv-state-normal");
                    $(".cv-infoView").removeClass("cv-state-list");
                }
            }, {
                title: "Information",
                element: ".cv-infoPanTool",
                content: "Sélectionner l'outil Info et cliquer à l'endroit désiré sur la carte",
                placement: "bottom",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "Information",
                element: undefined,
                placement: undefined,
                content: "Symbole indiquant l'emplacement pointé avec l'outil Info",
                orphan: true,
                onShown: function(tour) {
                    var mapController = window.cartovista.getMapController(window.cartovista.externalInterface.map),
                        layer = window.cartovista.externalInterface.map.getLayer("GEO09E01_CS_FRA_STA_GEN");
                    layer.getFeatures(null, function(result) {
                        mapController.zoomOnFeatures([result.features[0]], 1000);
                        mapController.requestInfo(result.features[0].centroid.x, result.features[0].centroid.y);
                    });
                }
            }, {
                title: "Information",
                element: ".cv-infoView .cv-infoView-attributes-list",
                content: "Liste des informations associées à l'entité géographique cliqué",
                placement: "left",
                onHide: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "Information",
                element: ".cv-infoView .cv-btnCopy",
                content: "Copier les données dans le presse-papier",
                placement: "left",
                onShown: function(tour) {
                    $(".cv-infoView .cv-btnCopy").toggleClass("cv-fade");
                },
                onHide: function(tour) {
                    $(".cv-infoView .cv-btnCopy").toggleClass("cv-fade");
                }
            }],
            onTourStart: function() {
                $(".cv-toolbar").css({
                    "opacity": "1",
                    "transition": "all 0 ease 0"
                });
            },
            onTourEnd: function() {
                $(".cv-toolbar").css({
                    "opacity": "",
                    "transition": ""
                });
            }
        },
        "panelLegende": {
            steps: [{
                title: "La légende",
                element: ".cv-btnToggleLegendView",
                content: "Légende : Afficher la légende de la carte",
                placement: "left",
                onShown: function(tour) {
                    window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("legendView").activate();
                }
            }, {
                title: "La légende",
                element: ".cv-legend-treeView ul:eq(0)",
                content: "Consulter la légende de chacune des thématiques présentes sur la carte",
                placement: "left"
            }, {
                title: "La légende",
                element: ".cv-btnExportLegend",
                content: "Exporter une image de la légende",
                placement: "left"
            }, ],
            onTourStart: function() {
                $(".cv-btnExportLegend").toggleClass("cv-fade")
            },
            onTourEnd: function() {
                $(".cv-btnExportLegend").toggleClass("cv-fade")
            }
        },
        "panelDonnees": {
            steps: [{
                title: "Données",
                element: ".cv-btnToggleDataView",
                content: "Afficher le tableau de données complet. Le chiffre entre parenthèses correspond au nombre total d'entités",
                placement: "top",
                onShown: function(tour) {
                    window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("dataView-allFeatures").activate();
                }
            }, {
                title: "Données",
                element: "#dataView-allFeatures .cv-ddlLayerList:first",
                content: "Alterner entre les différentes couches d'information disponibles",
                placement: "top",
                onShown: function(tour) {
                    $(this.element).click();
                },
                onHide: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "Données",
                element: "#dataView-allFeatures .k-grid-header .k-link:first",
                content: "Cliquer sur l'entête des colonnes pour trier les données par ordre ascendant ou descendant",
                placement: "top",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "Données",
                element: "#dataView-allFeatures .k-grid-header .k-grid-filter:first",
                content: "Appliquer différents filtres sur les données d'une colonne",
                placement: "top",
                onShown: function(tour) {
                    $(this.element).click();
                },
                onHidden: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "Données",
                element: "#dataView-allFeatures tr[role='row']:has('.cv-dataGridCell-labelLeft'):eq(4)",
                content: "Cliquer sur une ligne pour sélectionner l'entité. Utiliser les touches Maj ou Ctrl pour faire une sélection multiple",
                placement: "top",
                onShown: function(tour) {
                    $(this.element).click();
                }
            }, {
                title: "Données",
                element: "#dataView-allFeatures tr[role='row']:has('.cv-dataGridCell-labelLeft'):eq(4)",
                content: "L'entité sélectionnée est surlignée en bleu",
                placement: "top"
            }, {
                title: "Données",
                element: "#dataView-allFeatures tr[role='row']:has('.cv-dataGridCell-labelLeft'):eq(4)",
                content: "Double-cliquer sur la ligne pour zoomer la carte sur l'entité",
                placement: "top",
                onShown: function(tour) {
                    for (var i=0; i<2; i++) {
                        $(this.element).click();
                    }
                }
            }, {
                title: "Données",
                element: "#dataView-allFeatures .cv-btnCopy",
                content: "Copier le tableau de données dans le presse-papier",
                placement: "top",
                onShown: function(tour) {
                    $(this.element).toggleClass("cv-fade");
                    $(this.element).click();
                },
                onHide: function(tour) {
                    $(this.element).toggleClass("cv-fade");
                }
            }, {
                title: "Données",
                element: "[id='DataViewController (allFeatures)-btnExport']",
                content: "Exporter le tableau de données en format Excel",
                placement: "top",
                onShown: function(tour) {
                    $(this.element).toggleClass("cv-fade");
                },
                onHide: function(tour) {
                    $(this.element).toggleClass("cv-fade");
                }
            }, {
                title: "Données",
                    element: ".cv-btnDataSelectionView",
                content: "Afficher le tableau de données des entités sélectionnées seulement. Le chiffre entre parenthèses correspond au nombre d'entités sélectionnées",
                placement: "top",
                onShown: function(tour) {
                    if (!$("#dataView-selectedFeatures").hasClass("cv-panel-active")) {
                        $(this.element).click();
                    }
                },
            }, {
                title: "Données",
                element: "#dataView-selectedFeatures",
                content: "À noter que ce tableau se met automatiquement à jour en fonction des entités géographiques sélectionnées",
                placement: "top",
                onShown: function(tour) {
                    var layer = window.cartovista.externalInterface.map.getLayer("GEO09E01_CS_FRA_STA_GEN");
                    layer.selectFeatures([]);
                }
            }],
            onTourStart: function() {
                if ($("#dataView-allFeatures").hasClass("cv-state-statistics")) {
                    $("#dataView-allFeatures").toggleClass("cv-state-statistics");
                }
                if ($("#dataView-selectedFeatures").hasClass("cv-state-statistics")) {
                    $("#dataView-selectedFeatures").toggleClass("cv-state-statistics");
                }
            },
            onTourEnd: function() {
                window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("dataView-allFeatures").deactivate();
                window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("dataView-selectedFeatures").deactivate();
            }
        },
        "panelDiagrammes": {
            steps: [{
                title: "Les diagrammes",
                element: "#BbGraphs_bottomPanel_btn",
                content: "Afficher les données de la thématique active sous forme de diagrammes",
                placement: "top",
                onShown: function(tour) {
                    window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("BbGraphs_bottomPanel").activate();
                }
            }, {
                title: "Les diagrammes",
                element: "#BbGraphs_bottomPanel",
                content: "Survoler les diagrammes avec la souris pour afficher les valeurs",
                placement: "top",
            }, {
                title: "Les diagrammes",
                element: "#BbGraphs_bottomPanel",
                content: "Cliquer sur un élément d'un graphique pour zoomer la carte sur l'entité géographique associée",
                placement: "top",
            }, {
                title: "Les diagrammes",
                element: "#BbGraphs_bottomPanel",
                content: "Les diagrammes se mettent à jour en fonction des entités géographiques sélectionnés",
                placement: "top",
                onShow: function(tour) {
                    var layer = window.cartovista.externalInterface.map.getLayer("GEO09E01_CS_FRA_STA_GEN");
                    layer.getFeatures(null, function(result) {
                        layer.selectFeatures(_.map(_.sampleSize(result.features, 5), "id"));
                        window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("BbGraphs_bottomPanel").activate();
                    });
                },
                onHide: function(tour){
                  var layer = window.cartovista.externalInterface.map.getLayer("GEO09E01_GEO09E01_CS_FRA_STA_GENA_GEN");
                  layer.selectFeatures([]);
                  window.cartovista.getUIController(window.cartovista.externalInterface.map).findInstance("BbGraphs_bottomPanel").activate();
                }
            }, {
                title: "Les diagrammes",
                element: "#BbGraphs_bottomPanel .BbGraphs_printBtn",
                content: "Exporter les diagrammes dans un document PDF",
                placement: "left",
                onShow: function(tour) {
                    $("#BbGraphs_bottomPanel .BbGraphs_printBtn").removeClass("easeOut").addClass("easeIn");
                }
            }]
        }
    };

    for (var tour in config) {
        for (var i=0; i < config[tour].steps.length; i++) {
            config[tour].steps[i]["title"] = '<div class="row"><div class="col-md-10">' + config[tour].steps[i]["title"] + '</div><div class="col-md-2"><span class="float-end">' + (i+1) + '/' + config[tour].steps.length + '</span></div></div>';
        }
    }

    return {
        MODAL_HTML : modalHtml,
        TOURS_CONFIG : config,
        THEMESET_ID : "Freq_GEO09E01_CS_FRA_STA_GEN_1",
        DURATION : 6000,
    };

});
